export default __webpack_public_path__ + "static/media/EstudiantesIes.b63c52eb.png";